import { render, staticRenderFns } from "./ReservationInfoDesktop.vue?vue&type=template&id=44d31dae&scoped=true&"
import script from "./ReservationInfoDesktop.vue?vue&type=script&lang=js&"
export * from "./ReservationInfoDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ReservationInfoDesktop.vue?vue&type=style&index=0&id=44d31dae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d31dae",
  null
  
)

export default component.exports